import React, { createContext, useContext } from 'react';

import type { ButtonVariant } from '@change-corgi/design-system-legacy/theme';

import { useStarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';

type ButtonVariantContextType = Readonly<{
	getCTAVariant: (defaultVariant: ButtonVariant) => ButtonVariant;
}>;

const ButtonVariantContext = createContext<ButtonVariantContextType>({
	getCTAVariant: (defaultVariant) => defaultVariant,
});

export const useCTAButtonVariant = () => useContext(ButtonVariantContext);

export const ButtonVariantProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const {
		data: {
			viewer: {
				experiments: {
					starterExperienceDashboardSunriseV1: { variation },
				},
			},
		},
	} = useStarterDashboardV2PageData();

	const getCTAVariant = (defaultVariant: ButtonVariant): ButtonVariant => {
		return variation === 'variant1' ? 'secondary' : defaultVariant;
	};

	return (
		<ButtonVariantContext.Provider value={{ getCTAVariant }} data-qa="button-variant-context">
			{children}
		</ButtonVariantContext.Provider>
	);
};
